export const FIRST_NAME = "fn";
export const LAST_NAME = "ln";
export const EMAIL = "email";
export const PHONE_NUMBER = "phone";
export const TEST_PATIENTS = "tp";
export const LIMIT = "l";
export const PAGE = "p";
export const PATIENT_FIRST_NAME = "first_name";
export const PATIENT_LAST_NAME = "last_name";
export const TASK_ID = "tid";
export const TASK_TYPE = "t";
export const QUEUE_TYPE = "q";
export const ACTION_TAKEN = "action";
export const STATUS = "status";
export const PRODUCT = "product";
export const PHARMACY = "ph";
export const BILLING_MODE = "bl";
export const ORDER = "order";
export const ORDER_BY = "order_by";
export const LANGUAGE = "lang";
export const STATE = "state";
export const WAITING_ROOM_ID = "wrid";
export const ASSIGNEE_FIRST_NAME = "assignee_first_name";
export const ASSIGNEE_LAST_NAME = "assignee_last_name";
export const PATIENT_ID = "pid";
export const MEDICATION_FORM = "med_form";
export const TREATMENT = "treatment";
export const MEDICATION = "med";
export const DISPENSE_UNIT = "ds_u";
export const DOSAGE = "dosage";
export const SUBSCRIPTION_NAME = "sub";
export const ROLES = "role";
export const DISCOUNT = "discount";
export const CODE = "code";
export const CATEGORY = "category";
export const ID = "id";
export const FLAG = "flag";
export const TITLE = "title";
export const LABEL = "label";
export const REFILL = "refill_month";
export const GENDER = "gender";
